import { Col, Row } from "react-bootstrap";
import { GetBeforeAndAfterHitRanges } from "../../Calculators/RangeSplitter";

export default function Detail_5({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);
  let splitRanges = GetBeforeAndAfterHitRanges(item.scale.ranges);

  const isLast = splitRanges.afterHitRangeList.length === 0;
  const isFirst = splitRanges.beforeHitRangeList.length === 0;

  let margins = {
    cubeMargin: "0%",
    textMargin: "50%",
  };
  if (isFirst) {
    margins.cubeMargin = "-25%";
    margins.textMargin = "75%";
  }
  if (isLast) {
    margins.cubeMargin = "25%";
    margins.textMargin = "25%";
  }

  return (
    <Row className={"mb-3 mx-0"} style={{ marginBottom: "6px" }}>
      {!isSub && (
        <Row className={"justify-content-center  mx-0"} style={{ fontSize: 22, fontWeight: 700 }}>
          {item.scopeName}
        </Row>
      )}

      <div className={"py-3 rounded-4"} style={{ backgroundColor: isSub ? "white" : "#0048aa" }}>
        <Row>
          <Col className={"align-content-center"}>
            {isSub && <Row className={"detail-scope-name-blurred-wrap-up mb-2 px-3"}>{item.scopeName}</Row>}
            <Row style={{ color: !isSub ? "white" : "" }} className={"main-scope-name-detail-wrap-up-new px-3 pb-2"}>
              {item.name}
            </Row>
          </Col>
        </Row>
        <Row className={"mx-0"}>
          <Col className={"align-content-center"} xs={5}>
            <Row className={"_scale-detail-text-new-wrap-up  mx-0"}>
              <div
                className={"px-0"}
                style={{ color: !isSub ? "white" : "" }}
                dangerouslySetInnerHTML={{ __html: item.generalInformationText }}
              ></div>
            </Row>
          </Col>

          <Col xs={7} className={"align-content-center "}>
            <Row
              className={"justify-content-between mt-4 round-40px border border-2  px-2 mx-0"}
              style={{ borderColor: "#A6D1FF" }}
            >
              {splitRanges.beforeHitRangeList.map((range, i) => {
                return (
                  <Col xs={"auto"} className={"align-content-center p-0"}>
                    <div
                      style={{
                        backgroundColor: "white",
                        width: "fit-content",
                        height: "fit-content",
                        borderRadius: "50%",
                        padding: 0,
                      }}
                    >
                      <div
                        className={"scale-style-variable-opacity-wrap-up-round"}
                        style={{
                          opacity: (i + 1) * (1 / splitRanges.beforeHitRangeList.length),
                          backgroundColor: "#02a4ff",
                        }}
                      ></div>
                    </div>
                  </Col>
                );
              })}
              <Col xs={"auto"} className={"position-relative align-content-center  p-0"}>
                <Row className={"position-absolute translate-middle-x mx-0"} style={{ top: "-25px", left: "50%" }}>
                  <Col xs={"auto"} className={"position-relative px-0"} style={{ marginLeft: margins.textMargin }}>
                    <div
                      className={" z-0  rotated-div-cube  "}
                      style={{
                        marginTop: 2,
                        height: 15,
                        width: 15,
                        marginLeft: margins.cubeMargin,
                        backgroundColor: isSub ? "#007aff" : "#fff5ce",
                      }}
                    ></div>
                    <div
                      className={" px-2 z-1  detail-hit-range-name-above-wrap-up translate-middle-x text-nowrap"}
                      style={{
                        marginTop: -30,

                        backgroundColor: isSub ? "#007aff" : "#fff5ce",
                        color: isSub ? "white" : "#00428a",
                      }}
                    >
                      {splitRanges.hitRange.text}
                    </div>
                  </Col>
                </Row>

                {splitRanges.hitRange && (
                  <div className={"position-relative justify--center"} style={{ left: "50%" }}>
                    <SmoothDiamondHitRange
                      width={58}
                      height={58}
                      score={elementScore}
                      isSub={isSub}
                    ></SmoothDiamondHitRange>
                  </div>
                )}
              </Col>
              {splitRanges.afterHitRangeList.map((range, i) => {
                return (
                  <Col xs={"auto"} className={"align-content-center p-0"}>
                    <div
                      className={"scale-style-variable-opacity-wrap-up-round"}
                      style={{ backgroundColor: "#eeeeee" }}
                    ></div>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      </div>
    </Row>
  );
}

export const SmoothDiamondHitRange = ({ score, height, width, isSub }) => {
  return (
    <div
      className={"rotated-div-cube p-0"}
      style={{ width: width, height: height, backgroundColor: isSub ? "#284eaf" : "#007aff" }}
    >
      <div className={"straightened-div-cube"} style={{ width: width, height: height }}>
        <Row className={"justify-content-center h-100 mx-0"}>
          <Col
            xs={"auto"}
            className={"align-content-center hit-scale-style-variable-opacity-pdf p-0"}
            style={{ fontSize: "18px" }}
          >
            {score}
          </Col>
        </Row>
      </div>
    </div>
  );
};
